import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SkeletonComponent } from '../../shared/skeleton/skeleton.component';

/** Loading placeholder shaped like the offering detail page (sidebar + sections). */
@Component({
  selector: 'inexp-offering-skeleton',
  imports: [SkeletonComponent],
  templateUrl: './offering-skeleton.component.html',
  styleUrl: './offering-skeleton.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { 'aria-busy': 'true', 'aria-label': 'Loading offering' },
})
export class OfferingSkeletonComponent {
  readonly menuItems = Array.from({ length: 5 });
  readonly sections = Array.from({ length: 3 });
  readonly lines = Array.from({ length: 4 });
}
